import { Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input, TemplateRef, ChangeDetectorRef, input, AfterViewInit } from '@angular/core';
import { forkJoin, Observable, of, share, Subject, Subscription, takeUntil } from 'rxjs';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { AppGlobalsService } from '../services/app-globals.service';
import { IEditCheck } from '../services/auth-guard.service';
import { SiteDataService } from '../services/site-data.service';
import { IStarbaseNotificationObject, StarbaseNotificationTypes } from 'starbase-notification';
import { STContactDataService } from '../services/st-contact-data.service';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LU_MaterialService, LU_MaterialServiceDetail, ScaleTicketHeader, LU_STContactType, LU_Grid, LU_JobCategory, LU_JobCode, LU_MaterialSubCategory, LU_STUnitOfMeasure, LU_VehicleType, LU_Tax, LU_InvoiceBatch, STContact, Job, CustomerSelectComponent, StarbaseServicesProviderBase, AppGlobalsServiceBase, ScaleTicketStatusEnum, LU_MaterialServiceServiceBase, Site } from 'scaletech-core';
import { JobDataServiceBase } from 'scaletech-jobs';
import { StarbaseWizardComponent, IStarbaseWizardStep, StarbaseWizardStep } from 'starbase-wizard';
import { ISelectable, FilterParams } from 'starbase-launcher';
import { LU_JobCodeService } from '../services/lookups/lu-job-code.service';
import { LU_GridService } from '../services/lookups/lu-grid.service';
import { LU_ContactTypeService } from '../services/lookups/lu-contact-type.service';
import { LU_JobCategoryService } from '../services/lookups/lu-job-category.service';
import { LU_MaterialServiceService } from '../services/lookups/lu-material-service.service';
import { LU_TaxService } from '../services/lookups/lu-tax.service';
import { LU_UnitOfMeasureService } from '../services/lookups/lu-unit-of-measure.service';
import { LU_VehicleTypeService } from '../services/lookups/lu-vehicle-type.service';
import { VehicleDataService } from '../services/vehicle-data.service';
import { LU_MaterialSubCategoryService } from '../services/lookups/lu-material-sub-category.service';
import { LU_InvoiceBatchService } from '../services/lookups/lu-invoice-batch.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ScaleTicketHeaderServiceBase } from 'scaletech-tickets';
import { stringify } from 'querystring';

class ReportButton {
  text: string;
  icon: string;
  class: string;
  clickEvent: Function;
  tooltip: string;
  active: boolean;

  constructor(btnText = '', btnClass = 'btn-outline-secondary', btnClickEvent = undefined, active = false) {
    this.text = btnText;
    this.class = btnClass;
    this.clickEvent = btnClickEvent;
    this.active = active;
  }
}

@Component({
  selector: 'app-reports-wizard',
  templateUrl: './reports-wizard.component.html',
  styleUrls: ['./reports-wizard.component.css'],
  standalone: false
})
export class ReportsWizardComponent implements OnInit , AfterViewInit{
  @Input() darkMode = false;
  @Input() reportTitle = 'Report';
  @Input() jobCodes: LU_JobCode[];
  @Input() jobCategories: LU_JobCategory[];
  @Input() sthSvc: ScaleTicketHeaderServiceBase;
  @Input() contactSvc: STContactDataService;
  @Input() jobSvc: JobDataServiceBase;
  @Input() appGlobals: AppGlobalsServiceBase;
  @Input() sbSvcProvider: StarbaseServicesProviderBase;
  @Input() isSeasonal = false;
  @Input() warnForDateRange = false;
  @Input() buttons: StarbaseModalButton[] = [];
  @Input() allMaterials: LU_MaterialService[];
  @Input() selectedMaterials: LU_MaterialService[] = [];
  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @ViewChild('reportsWizard', { static: true }) reportsWizard: StarbaseWizardComponent<FilterParams<ScaleTicketHeader>>;
  @ViewChild('dateInput', { static: false }) dateInput: any;
  @ViewChild('step1', { static: true }) step1: TemplateRef<FilterParams<ScaleTicketHeader>>;
  @Output() wizardCompletedEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();
  @Output() wizardCancelledEmitter = new EventEmitter<FilterParams<ScaleTicketHeader>>();

  isAdmin = false;
  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;
  public showAll = true;
  public customersLoaded = true;
  public isProcessing = false;
  public filterParams: FilterParams<ScaleTicketHeader> = new FilterParams<ScaleTicketHeader>();
  public generateTonnageReportSteps: IStarbaseWizardStep<FilterParams<ScaleTicketHeader>>[];
  public filter = new FilterParams;
  statuses: any[] = [];
  materials: any[] = [];
  jobs: Job[] = [];
  allJobs: Job[] = [];
  customers: STContact[] = [];
  allCustomers: STContact[] = [];

  selectedMaterialIDs: Set<number> = new Set<number>();
  sites: Site[] = [];
  tempCustomers: STContact[] = [];
  tempJobs: Job[] = [];
  public dateRangeString = '';
  public customerString = '';
  public jobString = '';
  public materialString = '';

  selectCustomerMode = false;
  selectJobMode = false;

  currentMonth: number = new Date().getMonth();
  startYear: number = 2023;

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  reportableMonths: number[] = [
    this.currentMonth,
    this.currentMonth - 1 + (this.currentMonth - 1 < 0 ? 12 : 0),
    this.currentMonth - 2 + (this.currentMonth - 2 < 0 ? 12 : 0),
    this.currentMonth - 3 + (this.currentMonth - 3 < 0 ? 12 : 0),
    this.currentMonth - 4 + (this.currentMonth - 4 < 0 ? 12 : 0),
    this.currentMonth - 5 + (this.currentMonth - 5 < 0 ? 12 : 0),
    this.currentMonth - 6 + (this.currentMonth - 6 < 0 ? 12 : 0)
  ];

  reportableYears = [
    new Date().getFullYear(),
    new Date().getFullYear() - 1,
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 3,
    new Date().getFullYear() - 4
  ];

  summaryDateFrom: Date = null;
  summaryDateTo: Date = null;
  summaryReportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.setMonthDateRange(this.reportableMonths[0]), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[1]), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[2]), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[3]), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[4]), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[5]), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[6]), true)
  ];
  summaryReportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.setYearDateRange(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[4]), true)
  ];


  private now = new Date();
  private dateCustomClasses = [
    { date: this.now, classes: ['bg-info'] }
  ];

  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  year = null;
  filterJobCategoryUID = 0;
  filterJobCodeUID = 0;
  filterCustomerUID = 0;
  filterJobUID = 0;
  filterSiteUID = 0;
  filterWeighmaster = '';
  filterStatus: ScaleTicketStatusEnum[] = [];
  filterInvoiceUID = 0;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterCustomer = '';
  filterMaterial: LU_MaterialService[] = [];

  constructor(public sbCmpMsgSvc: StarbaseComponentMessageService,
    protected modalSvc: StarbaseModalDialogService,
    public jobCodeService: LU_JobCodeService,
    public gridModelService: LU_GridService,
    public contactTypeService: LU_ContactTypeService,
    public jobCategoryService: LU_JobCategoryService,
    public materialsServices: LU_MaterialServiceService,
    public taxModelService: LU_TaxService,
    public uomSvc: LU_UnitOfMeasureService,
    public vehicleTypeSvc: LU_VehicleTypeService,
    public vehicleSvc: VehicleDataService,
    public matSubCategorySvc: LU_MaterialSubCategoryService,
    public siteSvc: SiteDataService,
    public batchSvc: LU_InvoiceBatchService,
    private loginSvc: StarbaseLoginService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.generateTonnageReportSteps = [
      new StarbaseWizardStep(
        'Range Selection',
        this.step1,
        'auto'
      )
    ];

    this.generateTonnageReportSteps[0].stepValidationFunc = () => {
      this.generateTonnageReportSteps[0].stepValid$.next(/*!!this.filterDateFrom && !!this.filterDateTo &&*/ this.customersLoaded);
    };
    this.generateTonnageReportSteps[0].interStepFunc = (x: FilterParams<ScaleTicketHeader>) => {
      return of(void 0);
    }

    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    if (this.appGlobals.getStoredDarkModeSetting()) {
      this.bsConfig.containerClass = 'theme-default'
    }

    this.statuses = ScaleTicketHeader.GetStatusEnum();
    this.selectedMaterials = this.allMaterials;
    this.selectedMaterialIDs = new Set(this.selectedMaterials.map(m => m.uid));
    this.createMaterialString();

    this.materialsServices.getAllData(this.materialsServices.getAllUri).subscribe(m => {
      if (m && m.length) {
        this.materials = m.filter(x => x.requiresExitWeightInScaleTicket);
        if (this.selectedMaterials && this.selectedMaterials.length > 0) {
          this.materials.forEach(
            (t) => {
              if(this.selectedMaterialIDs.has(t.uid)) {
                t.selected = true;
              }
            }
          );
        }
      }
      this.cd.markForCheck();
    });

    this.jobSvc.getAllData(this.jobSvc.getAllUri).subscribe(j => {
      if (j && j.length) {
        this.allJobs = j;
      }
    });

    this.contactSvc.getCustomers().subscribe(c => {
      if (c && c.length) {
        this.allCustomers = c;
      }
    });

    setTimeout(() => {
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
    }, 500)
  }

  ngAfterViewInit(): void {
    this.dateInput.nativeElement.focus();
  }

  displayDateRangeWarning() {
    return this.warnForDateRange && this.filterDateFrom && this.filterDateTo && Math.floor((this.filterDateTo.getTime() - this.filterDateFrom.getTime()) / 86400000) > 31;
  }

  dateRangeChange(val: Date[]) {
    this.showAll = false;
    this.filterDateFrom = val[0];
    this.filterDateTo = val[1];
    if (this.filterDateFrom && this.filterDateTo) {
      this.dateRangeString = `${this.filterDateFrom.toLocaleDateString()} - ${this.filterDateTo.toLocaleDateString()}`;
    } else {
      this.dateRangeString = '';
    }

    if (this.filterDateFrom != null || this.filterDateTo != null) {
      this.filterDateFrom.setHours(0, 0, 0, 0);
      this.filterDateTo.setHours(23, 59, 59, 999);
    }

    if (this.filterDateFrom > this.filterDateTo) {
      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Invalid Date Range',
          'Please enter a valid Date Range'
        ));
    } else {
      // something to change to only customers active in date range
      this.customers = this.customers;
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
    }
    if (this.filterParams == null) {
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    else {
      this.filterParams.clearFilterArray();
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    this.updateCustomers();
    return;
  }

  setYear() {
    var year = (<HTMLInputElement>document.getElementById('year')).valueAsNumber;
    var dates = [];
    dates.push(new Date());
    dates.push(new Date());
    dates[0].setYear(year - 1);
    dates[0].setMonth(11);
    dates[0].setDate(1);
    dates[0].setHours(0);
    dates[0].setMinutes(0);
    dates[0].setSeconds(0);
    dates[1].setYear(year);
    dates[1].setMonth(11);
    dates[1].setDate(0);
    dates[1].setHours(23);
    dates[1].setMinutes(59);
    dates[1].setSeconds(59);
    if (year >= 2020 && year <= new Date().getFullYear()) {
      this.filterDateFrom = dates[0];
      this.filterDateTo = dates[1];

      if (this.filterParams == null) {
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }

      else {
        this.filterParams.clearFilterArray();
        this.filterParams = this.updateGeneralFilters(this.filterParams);
      }
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
    }

    return;
  }

  selectCustomer(customer: STContact) {
    this.jobs = undefined;
    if (customer) {
      this.customers = [];
      this.customers.push(customer);
      this.customerString = customer.organization;
    } else {
      this.customers = [];
      this.customerString = '';
    }

    this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
  }

  selectMaterial(material: LU_MaterialService) {
    if (material) {
      material.selected = !material.selected && !this.selectedMaterials.some((t) => t.uid === material.uid);
      if (material.selected && !this.selectedMaterials.some((t) => t.uid === material.uid)) {
        this.selectedMaterials.push(material);
      } else {
        this.selectedMaterials = this.selectedMaterials.filter((t) => t.uid !== material.uid);
      }
    } else {
      console.log(material);
    }


    this.createMaterialString();
  }

  selectJob(job: Job) {
    if (job === null) {
      this.jobs = [];
      this.jobString = '';
    } else if (job.selected) {
      this.jobs.push(job);
      this.jobString = this.jobs[0].jobDescription;
    } else {
      this.jobs = this.jobs.filter(x => x.uid !== job.uid);
    }
  }

  updateStatuses(status: ScaleTicketStatusEnum) {
    if (this.filterStatus.includes(status)) {
      this.filterStatus = this.filterStatus.filter(s => s != status);
    } else {
      this.filterStatus.push(status);
    }

    this.updateCustomers();
  }

  updateMaterials(materials: LU_MaterialService[]) {
    if(materials == null || materials.length == 0) {
      this.selectedMaterials = [];
      this.materialString = '';
      return;
    }

    materials.forEach(material => {
      if (this.selectedMaterials.includes(material)) {
        this.selectedMaterials = this.selectedMaterials.filter(m => m.uid !== material.uid);
      } else {
        this.selectedMaterials.push(material);
      }
    });

    this.createMaterialString();
  }

  updateGeneralFilters(filters: FilterParams<ScaleTicketHeader>) {
    this.appGlobals.addLocationFilters(filters);
    this.filterStatus.forEach(x => {
      filters.addToFilter('ScaleTicketStatus', x);
    });

    this.filterMaterial.forEach(x => {
      filters.addToFilter('MaterialUID', x.uid.toString());
    })

    if (this.filterDateFrom && this.filterDateTo) {
      filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
    }

    return filters;
  }

  updateCustomerFilters(filters: FilterParams<ScaleTicketHeader>) {
    if (this.customers == this.allCustomers) {
      return filters;
    }

    else {
      this.customers.forEach(x => {
        filters.addToFilter('Job.JobContactUID', x.contactUID);
      })
    }

    return filters;
  }

  updateMaterialFilters(filters: FilterParams<ScaleTicketHeader>) {
    this.filterMaterial = this.selectedMaterials;
    if (this.filterMaterial == this.materials) {
      return filters;
    }
    else {
      this.filterMaterial.forEach(x => {
        filters.addToFilter('MaterialUID', x.uid);
      })
    }
    return filters;
  }

  createMaterialString(){
    this.materialString = '';
    let visCount = 5;

    this.selectedMaterials.forEach((m, index) => {
      if(index < visCount) {
        if(index === 0){
            this.materialString = m.materialServiceCode
        } else {
            this.materialString += ', ' + m.materialServiceCode;
        }
      }
    });

    if(this.selectedMaterials.length > visCount) {
      this.materialString += `... +${this.selectedMaterials.length - visCount} Materials`;
    }
  }

  updateCustomers() {
    this.customersLoaded = false;
    this.isProcessing = true;
    var filters = new FilterParams<STContact>();

    filters.rpp = 32760;

    if (this.filterDateFrom && this.filterDateTo) {
      filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom);
      filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo);
    }

    if (this.filterStatus) {
      this.filterStatus.forEach(s => filters.addToFilter('ScaleTicketStatus', s));
    }

    const customerSearch$ = this.contactSvc.getDataByFilterParamsBroadSearch(this.contactSvc.customerBroadSearchUri, filters).pipe(share());
    const notifier = this.createAsyncNotification(customerSearch$);
    customerSearch$.subscribe(c => {
      this.customersLoaded = true;
      this.customers = c.collection;
      this.allCustomers = c.collection;
      this.jobs = this.allJobs.filter((j) => this.customers.some((c) => c.contactUID === j.jobContactUID));
      this.generateTonnageReportSteps[0].stepValidationFunc(null);
      //this.reportsWizard.detectChanges();
      notifier.updateTitle('Completed');
      this.isProcessing = false;
    });
    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  updateJobFilters(filters: FilterParams<ScaleTicketHeader>) {
    if (this.jobs == this.allJobs) {
      return filters;
    } else {
      this.jobs.forEach(x => {
        filters.addToFilter('JobUID', x.uid);
      })
    }

    return filters;
  }

  generateReport(filters: FilterParams<ScaleTicketHeader>) {
    let temp = new FilterParams<ScaleTicketHeader>();
    Object.assign(temp, filters);
    this.filterParams = temp;
    this.filterParams = this.updateGeneralFilters(this.filterParams);
    this.filterParams = this.updateCustomerFilters(this.filterParams);
    this.filterParams = this.updateMaterialFilters(this.filterParams);
    this.filterParams = this.updateJobFilters(this.filterParams);
    this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());
    this.wizardCompletedEmitter.emit(this.filterParams);
  }

  private createAsyncNotification(obs: Observable<any>): IStarbaseNotificationObject {
    let title = 'Please wait...';
    if (this.isProcessing) {
      title = 'Processing...';
    }

    return this.sbSvcProvider.notificationSvc.notificationBuilderAsync(
      title,
      null,
      StarbaseNotificationTypes.Notice, // or set undefined and 5th param = StarbaseNotificationSentiment.Notice
      obs
    );
  }

  setMonthDateRange(month: number) {
    var date1 = new Date();
    date1.setMonth(month, 1);
    date1.setHours(0, 0, 0, 0);
    var date2 = new Date();
    date2.setMonth(month + 1, 0);
    date2.setHours(23, 59, 59, 999);
    this.dateRangeChange([date1, date2]);
  }

  setYearDateRange(year: number) {
    var date1 = new Date(year, 0, 1);
    date1.setHours(0, 0, 0, 0);
    var date2 = new Date(year, 11, 31);
    date2.setHours(23, 59, 59, 999);
    this.dateRangeChange([date1, date2]);
  }
}
